import { useState } from 'react'
import { FileText } from 'lucide-react'
import { PageHeader } from '@/components/ui/PageHeader'
import { NotesConsultation } from './NotesConsultation'
import { ModificationExchange } from '@/components/exchange/ModificationExchange'

interface NotesStatsConsultationProps {
    onNavigateHome: () => void
    onNavigateToTenantNotes: (tenantId: string, tenantName: string) => void
    onNavigateToEdit: (exchangeData: any) => void
    onNavigateToBeneficiaire?: (id: string) => void
    initialTab?: 'notes' | 'stats'
    highlightExchangeId?: string
    autoOpenBeneficiaryId?: string
}

export const NotesStatsConsultation = ({
    onNavigateHome,
    onNavigateToTenantNotes,
    onNavigateToEdit,
    onNavigateToBeneficiaire,
    initialTab = 'notes',
    highlightExchangeId,
    autoOpenBeneficiaryId,
}: NotesStatsConsultationProps) => {
    const [activeTab, setActiveTab] = useState<'notes' | 'stats'>(initialTab)

    return (
        <div className="min-h-screen bg-gray-50">
            <PageHeader title="Consultation de notes et de stats" icon={<FileText size={20} />} onBack={onNavigateHome} />

            <div className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8">
                <div className="flex gap-0">
                    {(['notes', 'stats'] as const).map(tab => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors ${
                                activeTab === tab
                                    ? 'border-blue-600 text-blue-700'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                        >
                            {tab === 'notes' ? 'Notes' : 'Stats'}
                        </button>
                    ))}
                </div>
            </div>

            {activeTab === 'notes' && (
                <NotesConsultation
                    embedded
                    onNavigateHome={onNavigateHome}
                    onNavigateToTenantNotes={onNavigateToTenantNotes}
                    onNavigateToBeneficiaire={onNavigateToBeneficiaire}
                />
            )}

            {activeTab === 'stats' && (
                <ModificationExchange
                    embedded
                    onNavigateHome={onNavigateHome}
                    onNavigateToEdit={onNavigateToEdit}
                    highlightExchangeId={highlightExchangeId}
                    autoOpenBeneficiaryId={autoOpenBeneficiaryId}
                    onNavigateToBeneficiaire={onNavigateToBeneficiaire}
                />
            )}
        </div>
    )
}
